
import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/pages/Registration.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/incomes',
    name: 'incomes',
    component: () => import('@/pages/Incomes.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('@/pages/Record.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rules',
    name: 'rules',
    component: () => import('@/pages/Rules.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/pages/ChangePassword.vue'),
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// 路由守卫：检查登录状态
// router.beforeEach((to, from) => {
//   const authStore = useAuthStore()
//   const isAuthenticated = authStore.isAlreadyLogin // localStorage.getItem('isLoggedIn') === 'true'

//   if (to.meta.requiresAuth && !isAuthenticated) {
//     // 需要登录但未登录，跳转到登录页
//     return { name: 'login' }
//   }

//   if (to.name === 'login' && isAuthenticated) {
//     // 已登录但访问登录页，跳转到仪表盘
//     return { name: 'dashboard' }
//   }

//   // 允许导航
//   return true
// })

export default router
